import { Box } from '@mui/material';
import { getDemoData } from 'utils/helpers';
import { DetailsItem } from 'elements/DetailsItem';
import { formatStudentHousingPropertyType } from 'utils/formatBooleanYesNo';

const displayValue = (value, isDemo, demoKey) => {
  if (isDemo && demoKey) return getDemoData(demoKey);
  if (value == null || String(value).trim() === '') return 'No Data';
  return value;
};

export const DetailCard = ({ building, isDemo }) => {
  return (
    <Box
      display={'flex'}
      flexWrap={'wrap'}
      borderRadius={2}
      py={2}
      backgroundColor="rgba(248, 244, 249, 0.48)"
      border="1px solid #F8F4F9"
      sx={{
        '& > div': {
          flex: '1 1 25%',
          maxWidth: '25%',
          minWidth: 0,
        },
        '@media (max-width: 600px)': {
          '& > div': {
            flex: '1 1 100%',
            maxWidth: '100%',
          },
        },
      }}
    >
      <DetailsItem label="Phone" value={displayValue(building.phone, isDemo, 'phone')} />
      <DetailsItem
        label="Billing Street"
        value={displayValue(building.billingStreet, isDemo, 'address-street')}
      />
      <DetailsItem
        label="Email Address"
        value={displayValue(building.email_address, isDemo, 'email')}
      />
      <DetailsItem
        label="Secondary Email"
        value={displayValue(building.secondary_email, isDemo, 'email')}
      />
      <DetailsItem
        label="Operator Name"
        value={displayValue(building.landlord_name, isDemo, 'landlord-name')}
      />
      <DetailsItem
        label="Accounting Email"
        value={displayValue(building.accounting_email, isDemo, 'email')}
      />
      <DetailsItem
        label="Property Type"
        value={formatStudentHousingPropertyType(building.student_housing)}
      />
      <DetailsItem
        label="Billing State"
        value={displayValue(building.billingState, isDemo, 'address-state')}
        isLastItem
      />
    </Box>
  );
};
